<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Col span="12">
        <span style="display: inline-block;width: 10%">方案: </span>
        <span style="display: inline-block;width: 80%;overflow: hidden">{{ row.programme }}</span>
      </Col>
      <Col span="12">
        <span style="display: inline-block;width: 10%">评估: </span>
        <span style="display: inline-block;width: 80%;overflow: hidden">{{ row.estimate }}</span>
      </Col>
      <Col span="12">
        <span class="expand-key">图像: </span>
        <span class="expand-value">
<!--           <img style="width: 3rem;height: 3rem" v-for="(item,index) in row.imagePath.split(',')" :key="index" :src="item" alt="">-->
           <el-image
             v-for="(item,index) in row.imagePath.split(',')"
             :key="index" :src="item"
             style="width: 100px; height: 100px"
             :preview-src-list="row.imagePath.split(',')">
          </el-image>
        </span>
      </Col>
      <Col span="12">
        <span class="expand-key">视频: </span>
        <video v-for="(item,index) in row.viewPath.split(',')" width='200' height="200" :key="index" autoplay controls
               :src="item" alt=""></video>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  }
};
</script>
